export function cardSwiper() {
    const swiperContainers = document.querySelectorAll('.card-layout__wrapper.swiper');
    
    if (!swiperContainers.length || typeof Swiper === 'undefined') {
        return;
    }

    swiperContainers.forEach((swiperContainer) => {
        const prevButton = swiperContainer.querySelector('.card-layout__arrow--prev');
        const nextButton = swiperContainer.querySelector('.card-layout__arrow--next');
        const navigationElement = swiperContainer.querySelector('.card-layout__navigation');
        
        // Find the parent section to detect column layout
        const parentSection = swiperContainer.closest('.card-layout');
        
        // Skip swiper initialization if section has 'no-swiper' class
        if (parentSection?.classList.contains('no-swiper')) {
            return;
        }
        
        const columnLayout = parentSection?.classList.contains('col-5') ? 5 :
                            parentSection?.classList.contains('col-4') ? 4 :
                            parentSection?.classList.contains('col-3') ? 3 :
                            parentSection?.classList.contains('col-2') ? 2 : 4;
        
        // Configure breakpoints based on column layout
        // Maximum slides per layout should only show from 1366px
        let breakpointsConfig = {
            0: {
                slidesPerView: 1,
                spaceBetween: 15,
                
            }
        };
        
        // Add breakpoints based on column layout
        if (columnLayout >= 5) {
            breakpointsConfig[460] = {
                slidesPerView: 2,
                spaceBetween: 20,
                allowTouchMove: true,
            };
        }
        if (columnLayout >= 2) {
            breakpointsConfig[575] = {
                slidesPerView: 2,
                spaceBetween: 20,
                allowTouchMove: true,
            };
        }
        if (columnLayout >= 5) {
            breakpointsConfig[767] = {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove: true,
            };
        }
        
        // For col-3, show 3 slides at 1024px
        if (columnLayout === 3) {
            breakpointsConfig[1024] = {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove: true,
            };
        }
        
        // For col-4, show 3 slides at 1024px, then 4 at 1366px
        if (columnLayout === 4) {
            breakpointsConfig[1024] = {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove: true,
            };
        }
        
        // For col-5, show 3 slides at 1024px, then 5 at 1366px
        if (columnLayout === 5) {
            breakpointsConfig[1024] = {
                slidesPerView: 4,
                spaceBetween: 20,
                allowTouchMove: true,
            };
        }
        
        // Maximum slides only from 1366px
        if (columnLayout === 2) {
            breakpointsConfig[1366] = {
                slidesPerView: 2,
                spaceBetween: 0
            };
        } else if (columnLayout === 3) {
            breakpointsConfig[1366] = {
                slidesPerView: 3,
                spaceBetween: 0
            };
        } else if (columnLayout === 4) {
            breakpointsConfig[1366] = {
                slidesPerView: 4,
                spaceBetween: 0
            };
        } else if (columnLayout === 5) {
            breakpointsConfig[1366] = {
                slidesPerView: 5,
                spaceBetween: 0
            };
        }
        
        // Set default slidesPerView to 1 (mobile first)
        const defaultSlidesPerView = 1;

        // Function to check if both navigation buttons are disabled
        const checkNavigationState = () => {
            if (!navigationElement || !prevButton || !nextButton) {
                return;
            }
            
            const prevDisabled = prevButton.classList.contains('swiper-button-disabled');
            const nextDisabled = nextButton.classList.contains('swiper-button-disabled');
            
            if (prevDisabled && nextDisabled) {
                navigationElement.classList.add('card-layout__navigation--disabled');
            } else {
                navigationElement.classList.remove('card-layout__navigation--disabled');
            }
        };

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: defaultSlidesPerView,
            spaceBetween: 0,
            loop: false,
            speed: 300,
            allowTouchMove: false,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: breakpointsConfig,
            on: {
                init: checkNavigationState,
                slideChange: checkNavigationState,
                reachBeginning: checkNavigationState,
                reachEnd: checkNavigationState,
                resize: checkNavigationState,
            }
        });
    });
}